// reelConfig.ts

export const REEL_COLLECTION_COUNT = 2;
export const REEL_NUMBERS = 5;
export let SYMBOLS_PER_REEL = [8, 8, 8, 8, 8];
export const SYMBOL_WIDTH = 197;
export const SYMBOL_HEIGHT = 141;
export const REEL_WIDTH = SYMBOL_WIDTH;
export const REEL_DIVIDER = [0, 15, 0, 0, 15];
export const REEL_FRAME = 0;
export const NUMBER_OF_SYMBOLS = 13;
export const SHOWN_REELS_HEIGHT = SYMBOL_HEIGHT * 4; //SYMBOLS_PER_REEL;
export const REEL_x_POS = 64;
export const REEL_y_POS = [-403, -243, -243, -243, -403];
export const REELMASK_y_POS = [705, 282, 282, 282, 705];
export const WILD_ANTICIPATION_POS = {
    x: 888,
    y: 338
}
export const ANTICIPATION_CONFIG = [
    {
        "4": { x: 767, y: 541, scaleY: 0.8 }
    },
    {
        "5": { x: 767, y: 552, scaleY: 1 }
    },
    {
        "6": { x: 767, y: 543, scaleY: 1.2 }
    },
    {
        "7": { x: 767, y: 536, scaleY: 1.4 }
    },
    {
        "8": { x: 767, y: 568, scaleY: 1.6 }
    }

]
export const LOGO_Y = [570, 505, 425, 340, 250];
export const HOLDSPIN_SYMBOL_WIDTH = 197;
export const HOLDSPIN_SYMBOL_HEIGHT = 141;
export const HOLDSPIN_REEL_WIDTH = HOLDSPIN_SYMBOL_WIDTH;
export const HOLDSPIN_REEL_DIVIDER = 0;
export const HOLDSPIN_ROW_DIVIDER = 0;

export let VISIBLE_SYMBOLS_PER_REEL = [3, 4, 4, 4, 3];

export const REEL_BG_POS_ALL = [
    {
        "4": [{ bgX: -6.5, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 },
        { bgX: 246, bgY: 233, bgScaleX: 1, bgScaleY: 0.665, reelX: 212, reelY: -305 },
        { bgX: 880, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 }]
    },
    {
        "5": [{ bgX: -2, bgY: 292, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 },
        { bgX: 246, bgY: 169, bgScaleX: 1, bgScaleY: 0.83, reelX: 212, reelY: -220 },
        { bgX: 880, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 }]
    },
    {
        "6": [{ bgX: -6.5, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 },
        { bgX: 246, bgY: 80, bgScaleX: 1, bgScaleY: 0.99, reelX: 212, reelY: -166 },
        { bgX: 880, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 }]
    },
    {
        "7": [{ bgX: -6.5, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 },
        { bgX: 246, bgY: 0, bgScaleX: 1, bgScaleY: 1.15, reelX: 212, reelY: -104 },
        { bgX: 880, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 }]
    },
    {
        "8": [{ bgX: -6.5, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 },
        { bgX: 246, bgY: -97, bgScaleX: 1, bgScaleY: 1.33, reelX: 212, reelY: -44 },
        { bgX: 880, bgY: 291, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -373 }]
    }
];

// export const REEL_SCALE = [1.2, 1.2, 1, 0.8, 0.7];
export const REEL_SCALE = [1.2, 1, 0.9, 0.8, 0.7];
//export const REEL_SCALE = [1, 1, 1, 1, 1];

export let setVisibleSymbols = (newValues: number[]) => {
    VISIBLE_SYMBOLS_PER_REEL = newValues;
};

// import { TextStyle } from "pixi.js";

// export const WILD_MULT_STYLE = new TextStyle({
//     fontFamily: 'Arial',
//     fontSize: 100,
//     fill: "#fed716",
//     fontWeight: "bold",
//     stroke: '#4a1850',
//     dropShadow: true,
// });

export const GAME_LAYOUT_WIDTH = 2048;
export const GAME_LAYOUT_HEIGHT = 2048;